import { onBeforeUnmount, onMounted } from 'vue'
import { useRouter } from 'vue-router'

/**
 * Wizard browser-back guard.
 *
 * Mounts a sentinel history entry on mount so the first browser Back
 * press stays inside the wizard instead of leaving it. On popstate we
 * route the user to `targetLocation` (route name + optional params).
 *
 * Forward navigation via `router.push` (Cancel/Save buttons, hub → step,
 * step → hub) is unaffected because it does not fire popstate from the
 * user's perspective — those are programmatic navigations the wizard
 * controls directly.
 *
 * @param {{ name: string, params?: Record<string, string> }} targetLocation
 */
export function useWizardBackGuard(targetLocation) {
  const router = useRouter()
  let pushed = false

  const onPopState = () => {
    if (!pushed) return
    pushed = false
    router.push(targetLocation).catch(() => {})
  }

  onMounted(() => {
    window.history.pushState({ wizardSentinel: true }, '')
    pushed = true
    window.addEventListener('popstate', onPopState)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('popstate', onPopState)
    if (pushed && window.history.state?.wizardSentinel) {
      window.history.back()
    }
  })
}
